import { RosterListSortProperty } from 'src/app/components/ea-roster-list/ea-roster-list.models';
import { IVenueClickEvent } from 'src/app/components/venue-surface/venue-surface.models';

export class SetSelectedSurfaceClick {
    public static readonly type = '[Eventor] SetSelectedSurfaceClick';
    constructor(public surfaceClick: IVenueClickEvent | null) {}
}

export class ClearSelectedSurfaceCoord {
    public static readonly type = '[Eventor] ClearSelectedSurfaceCoord';
}

export class SetSelectedPlayerForTeamId {
    public static readonly type = '[Eventor] SetSelectedPlayerForTeamId';
    constructor(public playerId: string | undefined, public teamId: string) {}
}

export class ClearSelectedPlayerAndEvent {
    public static readonly type = '[Eventor] ClearSelectedPlayerAndEvent';
}

export class SetActiveRosterSort {
    public static readonly type = '[Eventor] SetActiveRosterSort';
    constructor(public selectedSortRosterListProperty: RosterListSortProperty) {}
}

export class SelectAdjacentEvent {
    public static readonly type = '[Eventor] SelectAdjacentEvent';
    constructor(public direction: 1 | -1) {}
}

export class SetSelectedTeamIdForEvents {
    public static readonly type = '[Eventor] SetSelectedTeamIdForEvents';
    constructor(public teamId: string | undefined) {}
}

export class ToggleShiftsForEvent {
    public static readonly type = '[Eventor] ToggleShiftsForEvent';
    constructor(public value: boolean) {}
}

export class ToggleUserCreatedEvents {
    public static readonly type = '[Eventor] ToggleUserCreatedEvents';
    constructor(public value: boolean) {}
}

export class ToggleEventingOverlayVisibility {
    public static readonly type = '[Eventor] ToggleEventingOverlayVisibility';
}

export class ToggleEventingOverlayPosition {
    public static readonly type = '[Eventor] ToggleEventingOverlayPosition';
}
